import { noop } from 'lodash';
import React from 'react';

import type { PokerContext } from '@swf/core/types/Poker';
import type { WidgetInstanceProps } from '@swf/core/types/Widget';

interface PokerProviderValue {
  state: PokerContext;
  setState: React.Dispatch<React.SetStateAction<PokerContext>>;
}

const PokerProvider = React.createContext<PokerProviderValue>({
  state: {
    banner: {},
    fetchService: noop as WidgetInstanceProps['fetchService'],
    activeGameIds: [],
    selectedGameIds: [],
    updateState: noop,
    isPolling: false,
    widgetId: ''
  },
  setState: () => noop
});

export default PokerProvider;
